import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import SelectDate from "./SelectDate"
import { flightActions } from "@/lib/redux/features/flight/reduce"
import { FC } from "react"
import { DatePickerProps } from "antd"
import dayjs from "dayjs"

import { useTranslation } from "react-i18next"

type SelectDateToProps = {
  size?: "small" | "default",
  layout?: "default" | "hero",
  heroSegment?: boolean,
  compact?: boolean,
  indexInputFlight: number,
  onChangeReturn?: (val?: boolean) => void,
  onlyContent?: boolean
}

const SelectDateTo: FC<SelectDateToProps> = ({ onlyContent, size = 'default', layout = 'default', heroSegment, compact, indexInputFlight, onChangeReturn }) => {
  const dateTo = useAppSelector(state => state.flight.inputFlights[indexInputFlight].dateTo)
  const { t } = useTranslation()

  return (
    <SelectDate
      size={size}
      layout={layout}
      heroSegment={heroSegment}
      compact={compact}
      isReturn
      onChangeReturn={onChangeReturn}
      value={dateTo}
      indexInputFlight={indexInputFlight}
      label={t("flight.return_date")}
      onlyContent={onlyContent}
    />
  )
}

export default SelectDateTo